import { render, staticRenderFns } from "./chinesePush.vue?vue&type=template&id=44d30df7&scoped=true"
import script from "./chinesePush.vue?vue&type=script&lang=js"
export * from "./chinesePush.vue?vue&type=script&lang=js"
import style0 from "./chinesePush.vue?vue&type=style&index=0&id=44d30df7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../Users/zhc/Documents/CF40/CF40-Java/cf40_pc_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d30df7",
  null
  
)

export default component.exports